import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDataDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.375 13.125H5.625V15H9.375V13.125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.375 0H5.625V1.875H9.375V0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 5.625H13.125V9.375H15V5.625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.875 5.625H0V9.375H1.875V5.625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 7.5H8.4375V3.75H6.5625V7.5H3.75L7.5 11.25L11.25 7.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.875 1.875H3.75V0H0.9375C0.375 0 0 0.375 0 0.9375V3.75H1.875V1.875Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0625 0H11.25V1.875H13.125V3.75H15V0.9375C15 0.375 14.625 0 14.0625 0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.125 13.125H11.25V15H14.0625C14.625 15 15 14.625 15 14.0625V11.25H13.125V13.125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.875 11.25H0V14.0625C0 14.625 0.375 15 0.9375 15H3.75V13.125H1.875V11.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconDataDownload;
